import { ArrowDownNarrowWide, Building2, ChevronDown, Euro } from 'lucide-react';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

interface SortOption {
	key: string;
	label: string;
	icon: React.ComponentType<{ className?: string }>;
}

interface SortButtonProps {
	onSortChange: (sortKey: string) => void;
	currentSort?: string;
}

const SortButton = ({ onSortChange, currentSort = 'premium' }: SortButtonProps) => {
	const { t } = useTranslation();

	const sortOptions: SortOption[] = [
		{ key: 'premium', label: t('quotes.sort.premium'), icon: Euro },
		{ key: 'insurer', label: t('quotes.sort.provider'), icon: Building2 }
	];

	return (
		<div className="hidden md:block" data-testid="sort-button-container">
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button
						variant="ghost"
						size="default"
						className="gap-2 pr-1 text-primary hover:bg-transparent hover:text-primary"
						icon={<ArrowDownNarrowWide className="w-4 h-4" />}
						iconRight={<ChevronDown className="w-4 h-4" />}
						data-testid="sort-button"
					>
						<span className="text-xs font-bold">{t('quotes.sort.title')}</span>
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent className="w-48 border-input" align="end">
					<DropdownMenuRadioGroup value={currentSort} onValueChange={onSortChange}>
						{sortOptions.map((option) => {
							const IconComponent = option.icon;
							return (
								<DropdownMenuRadioItem
									key={option.key}
									value={option.key}
									className="cursor-pointer"
									data-testid={`sort-button-${option.key}`}
								>
									<IconComponent className="w-4 h-4 mr-2 text-primary" />
									<span>{option.label}</span>
								</DropdownMenuRadioItem>
							);
						})}
					</DropdownMenuRadioGroup>
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};

export default SortButton;
